module.exports = __webpack_public_path__ + "img/mozz-icon.83bee397.webp";